/* lua.js generated code 0.3.0 */

var animDatas = table([1, 1, table()])
module.exports = animDatas
